import { environment } from '../../environments/environment';
import { mockInterceptor } from '../interceptor/mock.interceptor';
import { devInterceptor } from '../interceptor/dev.interceptor';
import { EnvironmentProviders, Provider } from '@angular/core';
import { AlarmGateway } from '../gateway/alarm/alarm.gateway';
import { AlarmSbGateway } from '../gateway/alarm/alarm-sb.gateway';

export const interceptors = [mockInterceptor];
if (!environment.production) {
  interceptors.push(devInterceptor);
}

export const providers: Array<Provider | EnvironmentProviders> = [
  {
    provide: AlarmGateway,
    useClass: environment.production ? AlarmSbGateway : AlarmSbGateway,
  },
];
